import router from "@/router";
import { AuthService } from "@/services/Auth";
import { Constantes } from "./Constantes";
import { TraduccionesTareas } from "./TraduccionesTareas";
import store from "@/store/index";
import i18n from "@/plugins/vuei18";

export interface IUtilidades {
    isDateOneGreaterThanDateTwo(dateOne: string, dateTwo: string): boolean;
    tieneTarea(tarea: string): string;
    isDateOneLessThanDateTwo(dateOne: string, dateTwo: string): boolean;
    getDateFromString(date: string): Date;
    calcularIdade(date: string): number;
    getYear(): number;
    monthYearFromDateString(date: string): string;
    daysInMonth(date: string): number;
    FECHA_HOY({ dias, mostrar_hora }: { dias?: number, mostrar_hora?: boolean });
    FORMATEAR_FECHA_WEB({ fecha, mostrar_hora }: { fecha: string, mostrar_hora?: boolean });
    formatearDecimalIdioma(value): number;
    isNullOrUndefinedOrEmpty(value: string): boolean;
    isNullOrUndefinedOrZero(value: number): boolean;
    guidIsEmpty(value: string): boolean;
    sleep(ms: number): Promise<any>;
    porcentagem(x: number, y: number): string;
    casasDecimales(value: number | string, digits?: number): string;
    toFixed(item: number | string, digits?: number): string;
    //@ts-ignore
    Message({ page, message, error }: { page: any, message: string, error?: boolean });
    reducir_cadena({ texto, qtde }): { texto: string, qtde?: number };
    nuevoHeader({ text, value, width, sortable, filter, align, fecha, fecha_hora, moneda, decimal, porcentaje }: {
        text: string, value: string, width?: string, sortable?: boolean,
        filter?: any, align?: string, fecha?: boolean, fecha_hora?: boolean,
        moneda?: boolean, decimal?: boolean, porcentaje?: boolean,
    }): HeaderTemplate;
    traduccion({ texto, tag, replace }: { texto: string, tag?: string, replace?: Array<[string, string]> }): string;
    stringToTable(strItems: string, headers: Array<string>, separadorColumnas: string, separadorFilas: string): Array<any>;
    CERO(): string;
    UNO(): string;
    DOS(): string;
}

export class Utilidades {
    /**
     * Recebe duas datas no formato DD/MM/YYYY e retorna se a primeira é maior que a segunda
     * @param {string} dateOne 
     * @param {string} dateTwo 
     */
    public static isDateOneGreaterThanDateTwo(dateOne: string, dateTwo: string): boolean {
        let _date1 = this.getDateFromString(dateOne);
        let _date2 = this.getDateFromString(dateTwo);

        return _date1 >= _date2;
    }

    /**
     * Recebe duas datas no formato DD/MM/YYYY e retorna se a primeira é menor que a segunda
     * @param {string} dateOne 
     * @param {string} dateTwo 
     */
    public static isDateOneLessThanDateTwo(dateOne: string, dateTwo: string): boolean {
        let _date1 = this.getDateFromString(dateOne);
        let _date2 = this.getDateFromString(dateTwo);

        return _date1 <= _date2;
    }

    /**
     * Recebe uma data no formato DD/MM/YYYY e retorna o valor convertido para Date
     * @param {string} date 
     */
    public static getDateFromString(date: string): Date {
        let _split = date.split("/");

        return (new Date(parseInt(_split[2]), parseInt(_split[1]) - 1, parseInt(_split[0])));
    }

    /**
     * Recebe uma data no formato DD/MM/YYYY e retorna a idade até o dia atual
     * @param {string} date      
     */
    public static calcularIdade(date: string): number {
        if (this.isNullOrUndefinedOrEmpty(date))
            return 0;

        if (date.length != 10)
            return 0;

        let birth = Utilidades.getDateFromString(date);
        let today = new Date();
        let age = today.getFullYear() - birth.getFullYear();
        let month = today.getMonth() - birth.getMonth();
        if (month < 0 || (month === 0 && today.getDate() < birth.getDate())) {
            age--;
        }

        if (0 > age)
            return 0;
        else return age;
    }

    public static get CERO(): string {
        return "UABUAF8ARgBBAFIATwBfADAAMAAyADAA";
    }

    public static get UNO(): string {
        return "UABUAF8ARgBBAFIATwBfADAAMAAyADEA";
    }

    public static get DOS(): string {
        return "UABUAF8ARgBBAFIATwBfADAAMAAyADIA";
    }

    public static get N(): string {
        return "UABUAF8ARgBBAFIATwBfADAAMAAyAE4A";
    }

    public static get S(): string {
        return "UABUAF8ARgBBAFIATwBfADAAMAAyAFMA";
    }

    public static getYear(): number {
        return new Date().getFullYear();
    }

    public static OPENNAUTAS(): string {
        return "OPENNAUTAS";
    }

    public static CARGAR_COMBO_CON_HEADER(combo: Array<any>) {
        let autocomplete = new Array<AutoCompleteTemplate>();

        let headers = [...new Set(combo?.filter(x => !Utilidades.isNullOrUndefinedOrEmpty(x.header)).map(x => x.header))];

        if (headers?.length > 0) {
            headers.forEach(x => {
                let listado = combo.filter(y => y.header == x);

                if (listado?.length > 0) {
                    autocomplete.push(AutoCompleteTemplate.add({ text: "", value: "", header: x }))

                    listado.forEach(x => { autocomplete.push(AutoCompleteTemplate.add({ text: x.texto, value: x.id, css: x.css_texto, defecto: x.enc_defecto })) });
                }
            });
        }
        else {
            combo.forEach(x => { autocomplete.push(AutoCompleteTemplate.add({ text: x.texto, value: x.id, css: x.css_texto })) });
        }

        return autocomplete;

    }

    public static cargarGrafica(g: Array<any>) {
        let grafica = new ChartData();
        let ds = new datasets();
        let colores = Object.values(COLORES);

        let nombres = [...new Set(g?.filter(x => !Utilidades.isNullOrUndefinedOrEmpty(x.nombre)).map(x => x.nombre))];
        let agrupacion = [...new Set(g?.filter(x => !Utilidades.isNullOrUndefinedOrEmpty(x.agrupacion)).map(x => x.agrupacion))];
        let nombre = (nombres?.length > 0) ? nombres[0] : "";
        //Carga los textos
        grafica.labels = [...new Set(g?.filter(x => !Utilidades.isNullOrUndefinedOrEmpty(x.label_eje_x.toString())).map(x => x.label_eje_x))];

        //Si tiene dos o mas agrupacion, es creado multiplos datasets
        if (agrupacion?.length > 0) {
            agrupacion.forEach((agr, index) => {
                //Filtra los datos por agrupacion
                let datosFiltrados = g.filter(x => x.agrupacion == agr);
                let color = !this.isNullOrUndefinedOrEmpty(datosFiltrados[0]?.color) ? COLORES[datosFiltrados[0].color] : colores[index % colores.length];
                ds = new datasets();

                //Carga los datos
                ds.data = [...new Set(datosFiltrados?.filter(x => !Utilidades.isNullOrUndefinedOrEmpty(x.valor?.toString())).map(x => x.valor))];

                //Esa es la color de fondo en los graficos de pizza/barra y color de la línea
                //Carga la color desde BBDD, si no tiene carga de las colores del vue
                ds.backgroundColor = color;

                //Color de la línea y del separador en los graficos de pizza y barra
                ds.borderColor = color;

                //Nombre de los datos en subtitulo y tooltip
                ds.label = agr;

                grafica.datasets.push(ds);
            });

        } else {
            //Si no hay agrupación, solo carga los datos una vez
            ds.data = [...new Set(g?.filter(x => !Utilidades.isNullOrUndefinedOrEmpty(x.valor?.toString())).map(x => x.valor))];

            grafica.labels = [...new Set(g?.filter(x => !Utilidades.isNullOrUndefinedOrEmpty(x.label)).map(x => x.label))];

            ds.backgroundColor = [...new Set(g.map((x, index) => colores[index % colores.length]))];

            //Verifica si la tabla retorna colores
            let color = g?.map(x => x.color).length > 0 ? g?.map(x => x.color)[0] : undefined;

            ds.borderColor = this.isNullOrUndefinedOrEmpty(color) ? undefined : color;

            ds.label = nombre;

            grafica.datasets.push(ds);
        }

        return grafica;
    }

    /**
     * Recebe uma data no normato DD/MM/YYYY e retorna no formato MMMM/YYYY
     * @param date 
     */
    public static monthYearFromDateString(date: string): string {
        let data = this.getDateFromString(date);

        return data.toLocaleDateString("pt-br", { month: "long" }).toUpperCase() + '/' + data.getFullYear();
    }

    /**
     * Recebe uma data no formato DD/MM/YYYY e retorna a quantidade de dias no mês
     * @param date 
     */
    public static daysInMonth(date: string): number {
        let data = this.getDateFromString(date.replaceAll("-", "/"));
        let aux = new Date(data.getFullYear(), data.getMonth() + 1, 0);
        return aux.getDate();
    }

    public static FORMATEAR_FECHA_WEB({ fecha, mostrar_hora = false }) {
        if (this.isNullOrUndefinedOrEmpty(fecha)) {
            return "";
        }

        let year, moth, day, hour, minute, second, fecha_formateada, _split_date, _split_hour, formato = '';

        //la fecha vá venir siempre (js) 2023-02-25 12:00:51.561 -> yyyy-mm-dd hh:MM:ss:ms
        //desde BBDD puede venir 2023-02-25 12:00:51.561 o solamente 2023-02-25

        try {

            fecha = fecha.replaceAll('T', ' ').replaceAll('Z', '');
            formato = AuthService.getUsuario().formato_fecha;

            //eso es cuando desde BBDD devuelve solamente el tipo Date 2024-02-14
            if ((fecha.length == 10)) {
                _split_date = fecha.split("-");
                year = _split_date[0];
                moth = _split_date[1];
                day = _split_date[2];
            }
            else {
                if (fecha.indexOf(" ") > 0) {
                    _split_date = fecha.split(" ")[0].split("-");
                    _split_hour = (fecha.includes(" ")) ? fecha.split(" ")[1].split(":") : [];

                    year = _split_date[0];
                    moth = _split_date[1];
                    day = _split_date[2];
                }
            }

            if (mostrar_hora && (_split_hour.length > 0)) {
                hour = _split_hour[0];
                minute = _split_hour[1];
                second = _split_hour[2].split('.')[0];
            }

            //2023-04-18 12:29:43.860
            switch (formato.toLocaleLowerCase()) {
                case 'mm/dd/yyyy':
                    year = _split_date[0];
                    moth = _split_date[1];
                    day = _split_date[2];

                    if (hour) {
                        fecha_formateada = `${moth}/${day}/${year} ${hour}:${minute}:${second}`;
                    } else {
                        fecha_formateada = `${moth}/${day}/${year}`;
                    }

                    break;
                case 'dd/mm/yyyy':
                    if (hour) {
                        fecha_formateada = `${day}/${moth}/${year} ${hour}:${minute}:${second}`;
                    } else {
                        fecha_formateada = `${day}/${moth}/${year}`;
                    }
                    break;
            }

        } catch (ex) {
            fecha_formateada = '';
        }

        return fecha_formateada;
    }

    public static FORMATEAR_FECHA_BBDD({ fecha }) {
        try {
            if (Utilidades.isNullOrUndefinedOrEmpty(fecha?.toString())) {
                return "";
            } else {
                let esAceptoBBDD = AuthService.getUsuario()?.formato_fecha?.toLocaleLowerCase()?.trim() == "dd/mm/yyyy";

                if (esAceptoBBDD)
                    return fecha;
                else {
                    let f = new Date(fecha);

                    if (isNaN(f.getDate())) {
                        return "";
                    } else {
                        return i18n.d(f, "short", "es-ES");
                    }
                }
            }
        }
        catch (e) {
            console.log(e)
            return "";
        }
    }

    public static FECHA_HOY({ dias = 0, mostrar_hora = false }) {
        const hoy = new Date()
        hoy.setDate(hoy.getDate() + dias)
        let fecha = hoy.toISOString().replaceAll('T', ' ').replaceAll('Z', '')

        //hoy.toISOString() -> 2022-03-05T13:28:56.665Z
        //hoy 2022-03-05 13:28:56.665
        if (mostrar_hora) {
            return Utilidades.FORMATEAR_FECHA_WEB({ fecha: fecha, mostrar_hora: mostrar_hora });
        } else {
            //(2022-03-05 13:28:56.665).substr(0, 10) ->  2022-03-05
            return Utilidades.FORMATEAR_FECHA_WEB({ fecha: fecha.substr(0, 10) });
        }
    }

    public static MES_HOY({ meses = 0, formato = "mm/yyyy" }) {
        const hoy = new Date()
        hoy.setDate(hoy.getMonth() + meses)
        let fecha = hoy.toISOString().replaceAll('T', ' ').replaceAll('Z', '')

        //hoy.toISOString() -> 2022-03-05T13:28:56.665Z
        //hoy 2022-03-05 13:28:56.665        
        //(2022-03-05 13:28:56.665).substr(0, 7) ->  2022-03
        let mes_formateado = '';

        switch (formato.toLocaleLowerCase()) {
            case 'mm/yyyy':
                //2022-03
                mes_formateado = fecha.substr(5, 2).toString() + '/' + fecha.substr(0, 4).toString();
                break;
            case 'mm-yyyy':
                mes_formateado = fecha.substr(5, 2).toString() + '-' + fecha.substr(0, 4).toString();
                break;
            default:
                //yyyy-mm
                mes_formateado = fecha.substr(0, 7).toString();
                break;
        }

        return mes_formateado;
    }

    public static Left(texto: string, cantidad: number = 2): string {
        let nuevo_valor = '';

        try {
            if (cantidad <= 0)
                nuevo_valor = '';
            else if (cantidad > String(texto).length)
                nuevo_valor = texto;
            else
                nuevo_valor = String(texto).substring(0, cantidad);

            if (nuevo_valor.length == 1) {
                nuevo_valor = "0" + nuevo_valor;
            }
        } catch (x) {
            nuevo_valor = '';
        }

        return nuevo_valor;
    }

    public static Right(texto: string, cantidad: number): string {
        let nuevo_valor = '';

        try {
            if (cantidad <= 0)
                nuevo_valor = '';
            else if (cantidad > String(texto).length)
                nuevo_valor = texto;
            else {
                var iLen = String(texto).length;
                nuevo_valor = String(texto).substring(iLen, iLen - cantidad);
            }

            if (nuevo_valor.length == 1) {
                nuevo_valor = "0" + nuevo_valor;
            }

        } catch (x) {
            nuevo_valor = '';
        }

        return nuevo_valor;
    }

    public static formatearDecimalIdioma(value): number {
        return value.toString().replace(',', '.');
    }

    public static formValidate(form: any): boolean {
        if (form !== null && form !== undefined)
            return (form as Vue & { validate: () => boolean; }).validate();
        else return true;
    }

    public static formResetValidation(form: any): boolean {
        if (form !== null && form !== undefined)
            return (form as Vue & { resetValidation: () => boolean; }).resetValidation();
        else return true;
    }

    public static async fileToBase64(file: any): Promise<string> {
        let result = new Promise((resolve) => {
            let reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result);
        });

        return result.then(function (res) { return res.toString().split(',')[1] as string; });
    }

    public static reducir_cadena({ texto, qtde = 30 }: { texto: string, qtde?: number }): string {
        let texto_reducido = texto;

        try {

            if (qtde == undefined || qtde == null) {
                qtde = 30
            }

            if (texto == undefined || texto == null)
                texto_reducido = '';
            else if (texto.length <= qtde)
                texto_reducido = texto;
            else
                texto_reducido = texto.substring(0, qtde - 3) + "...";
        } catch (ex) {
            texto_reducido = '';
        }

        return texto_reducido;

    }

    /**
     * Receive a string and returns if has a 'valid' value
     * @param value 
     */
    public static isNullOrUndefinedOrEmpty(value: string): boolean {
        if (typeof (value) != "string")
            return true;

        let isNullOrUndefined = value === null || value === undefined;

        if (isNullOrUndefined)
            return true;
        else
            return value.trim() === '';
    }

    public static isNullOrUndefinedOrZero(value: number): boolean {
        let isNullOrUndefined = value === null || value === undefined;
        if (this.isNullOrUndefinedOrEmpty(value?.toString())) return true;

        if (isNullOrUndefined)
            return true;
        else
            return value === 0;
    }

    public static guidIsEmpty(value: string): boolean {
        return value === "00000000-0000-0000-0000-000000000000" ||
            value.replace("-", "") === "00000000000000000000000000000000" ||
            this.isNullOrUndefinedOrEmpty(value);
    }

    public static sleep(ms: number): Promise<any> {
        return new Promise(resolve => setTimeout(resolve, ms));
    }

    public static porcentagem(x: number, y: number): string {
        let value = (y / x) * 100;

        return value.toFixed(2) + "%";
    }


    public static traduccion({ texto, tag, replace }: { texto: string, tag: string, replace?: Array<[string, string]> }): string {
        return TraduccionesTareas.traduccion({ texto, tag, replace });
    }

    public static traduccir_cabeceras(cabeceras: Array<HeaderTemplate>) {
        cabeceras.forEach(x => {
            if (!this.isNullOrUndefinedOrEmpty(x.text)) {
                if (this.isNullOrUndefinedOrEmpty(x.tag_texto)) {
                    x.text = this.traduccion({ texto: x.text, tag: "" });
                } else {
                    x.text = this.traduccion({ texto: x.text, tag: x.tag_texto });
                }
            }
        });

        return cabeceras;
    }

    public static Message({ message, error = false, timeout = 5000, color = null, icono = null, left = null, bottom = null, top = null, right = null }: { message: string, error?: boolean, timeout?: number, color?: string, icono?: string, left?: boolean, bottom?: boolean, top?: boolean, right?: boolean }) {

        if (error) {

            //Klauder 28/02/2024 limitamos la cantidad de caracteres
            if (message.length < 512) {
                timeout = -1 //Klauder Dias - 21/02/2024 - En los errores por defecto el mensaje no se vaya 
            }
        }

        let aux = router.currentRoute.matched[0].instances.default;
        (aux as any).snackbar({ mensaje: message, error: error, timeout: timeout, color: color, icono: icono, left: left, bottom: bottom, top: top, right: right });
    }

    public static sessionError(error) {
        let aux = router.currentRoute.matched[0].instances.default;
        (aux as any).sessionError(error);
    }

    public static nuevoHeader({ text, value, width, sortable, filter, align, clase_td, icon, fecha, fecha_hora,
        moneda, decimal, porcentaje }:
        {
            text: string, value: string, width?: string, sortable?: boolean, filter?: any, align?: string, clase_td?: string,
            icon?: boolean, fecha?: boolean, fecha_hora?: boolean, moneda?: boolean,
            decimal?: boolean, porcentaje?: boolean,
        }): HeaderTemplate {

        if (this.isNullOrUndefinedOrEmpty(align)) {
            if (moneda || decimal || porcentaje) {
                align = 'right';
            }
            else if (icon) {
                align = 'center';
            }
            else {
                align = 'left';
            }
        }

        if (clase_td == null || clase_td == undefined) {
            clase_td = ''
        }

        if (icon) {
            width = '0%';
            clase_td += ' p-0';
            sortable = false;
        }

        if (sortable == null || sortable == undefined)
            sortable = true;

        let tag_texto = '';
        return new HeaderTemplate(text, value, width, sortable, filter, align, tag_texto, clase_td, fecha, fecha_hora,
            moneda, decimal, porcentaje);
    }

    public static tiene_tarea(tarea: string): boolean {
        return TraduccionesTareas.tiene_tarea(tarea);
    }

    public static clonarObjeto(object) {
        return JSON.parse(JSON.stringify(object))
    }


    public static toFixed(item: number | string, digits = 2 as number): number {
        try {
            if (!item)
                return item as number;

            return parseFloat(parseFloat(item?.toString())?.toFixed(digits));
        }
        catch {
            return item as number;
        }
    }

    public static redondear(item: number, digits = 2 as number): number {
        try {

            let n = Math.pow(10, digits);

            if (!item)
                return item as number

            return (Math.round((item + Number.EPSILON) * n) / n) as number;
        }
        catch {
            return item as number
        }
    }

    public static casasDecimales(value: number | string, digits = 2 as number): any {
        try {
            if (!value)
                return value;
            return parseFloat(value?.toString()).toLocaleString(store.state.locale,
                { minimumFractionDigits: 2, maximumFractionDigits: digits })
        }
        catch {
            return value;
        }
    }

    public static formatearMoneda(value) {

        if (isNaN(Number.parseFloat(value))) {
            return "";
        } else return i18n.n(value, "currency");
    }

    public static formatearFechaGrafica(val, time = false, mes = false) {
        try {
            if (Utilidades.isNullOrUndefinedOrEmpty(val?.toString())) {
                return "";
            } else {
                let fecha = new Date(val);

                if (mes) {
                    let ano = val.toString().substring(0, 4);
                    let m = val.toString().substring(4, 6);
                    return `${m}/${ano}`;
                } else if (isNaN(fecha.getDate())) {
                    //Fecha no valida
                    return "";
                } else {
                    return i18n.d(fecha, time ? "time" : "short").replace(",", "");
                }
            }
        }
        catch {
            console.log("err")
            return "";
        }
    }

    public static objectToQueryString(obj: Object): string {
        try {
            var queryParams = new Array<string>();

            Object.keys(obj).forEach(x => {
                if (!Utilidades.isNullOrUndefinedOrEmpty(obj[x])) {
                    queryParams.push(`${x}=${obj[x]}`);
                }
            });

            return queryParams.join("&");
        } catch {
            return "";
        }
    }

    public static stringToArray(str: string, separador: string): Array<string> {
        return str.split(separador);
    }

    public static stringToTable(strItems: string, headers: Array<string>, separadorColumnas: string, separadorFilas: string): Array<any> {
        let arr = new Array<any>();
        let filas = this.stringToArray(strItems, separadorFilas);

        if (filas) {
            for (let i in filas) {
                let item = {};

                let columnas = this.stringToArray(filas[i], separadorColumnas);

                for (let j in columnas) {
                    item[headers[j]] = columnas[j];
                }

                arr.push(item);
            }
        }

        return arr;
    }

    public static forzarActualizacionPantalla(context: any) {
        context.$forceUpdate();
    }


    public static setCookie(name, value, minutes) {
        var expires = "";
        var expiration = "";

        if (minutes) {
            var date = new Date();
            date.setTime(date.getTime() + (minutes * 60000)); //Minutes to Miliseconds
            expires = "; expires=" + date.toUTCString();
            expiration = date.toUTCString();
        }

        document.cookie = name + "=" + (`${value}#|#${expiration}` || "") + expires + "; path=/";
    }

    public static getCookie(name) {
        var nameEQ = name + "=";
        var ca = document.cookie.split(';');
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length)?.split("#|#")[0];
        }
        return null;
    }

    public static deleteCookie(name) {
        document.cookie = name + '=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
    }

    public static getCookieExpiration(name): Date | null {
        let cookieValue = "";

        var nameEQ = name + "=";
        var ca = document.cookie.split(';');
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) == 0) cookieValue = c.substring(nameEQ.length, c.length);
        }

        if (cookieValue) {
            const parts = cookieValue.split('#|#');
            if (parts.length > 1) {
                return new Date(parts[1]);
            }
        }
        return null;
    }
}

export class Rules {
    public static required(value): boolean | string | number {

        let texto = Constantes.CAMPO_OBLIGATORIO;

        switch (typeof (value)) {
            case "string":
                return !!value || texto;
            case "number":
                //return ((value as number >= 0) ? true : texto);
                if (value.toString() != '') {
                    return (/(^-|^\d)|\d+/g).test(value.toString());
                } else {
                    return texto;
                }
            case "bigint":
                break;
            case "boolean":
                return (value ? true : texto)
                break;
            case "symbol":
                break;
            case "undefined":
                return texto;
            case "object":
                return ((value?.length == 0 as number >= 0) ? true : texto);
            case "function":
                break;
            default:
                return !!value || texto;
        }
    }

    public static required_multiple(value): boolean | string {

        let texto = Constantes.CAMPO_OBLIGATORIO;

        switch (typeof (value)) {
            case "object":
                return (value?.length == 0) ? texto : true;
            default:
                return texto;
        }
    }

    public static complexPassword(pwd, minLength = 6, numUpper = 1, numLower = 1, numNumbers = 1, numSpecial = 1, cantidadCumplir = 3): boolean | string {
        let comprobaciones = 0;
        let retorno = false;
        try {
            const upper = /[A-Z]/g;
            const lower = /[a-z]/g;
            const number = /[0-9]/g;
            const special = /[^a-zA-Z0-9]/g;

            if (pwd?.length < minLength) {
                return "Cantidad Mínima: " + minLength + " caracter(es)"
            }

            if (pwd?.match(upper)?.length >= numUpper && numUpper > 0) {
                comprobaciones += 1;
            }

            if (pwd?.match(lower)?.length >= numLower && numLower > 0) {
                comprobaciones += 1;
            }

            if (pwd?.match(number)?.length >= numNumbers && numNumbers > 0) {
                comprobaciones += 1;
            }

            if (pwd?.match(special)?.length >= numSpecial && numSpecial > 0) {
                comprobaciones += 1;
            }

            retorno = comprobaciones >= cantidadCumplir;
        } catch (ex) {
            console.log(ex)
            retorno = false;
        }

        return (retorno ? true : 'Las claves no cumplen los requisitos de complejidad');
    }


    public static complexPasswordCounter(pwd, minLength = 6, numUpper = 1, numLower = 1, numNumbers = 1, numSpecial = 1): number {
        let comprobaciones = -1;
        try {
            const upper = /[A-Z]/g;
            const lower = /[a-z]/g;
            const number = /[0-9]/g;
            const special = /[^a-zA-Z0-9]/g;

            if (pwd?.length >= minLength) {
                comprobaciones += 1;
            }

            if (pwd?.match(upper)?.length >= numUpper && numUpper > 0) {
                comprobaciones += 1;
            }

            if (pwd?.match(lower)?.length >= numLower && numLower > 0) {
                comprobaciones += 1;
            }

            if (pwd?.match(number)?.length >= numNumbers && numNumbers > 0) {
                comprobaciones += 1;
            }

            if (pwd?.match(special)?.length >= numSpecial && numSpecial > 0) {
                comprobaciones += 1;
            }

        } catch (ex) {
            // console.log(ex);
            comprobaciones = 0;
        }

        return comprobaciones
    }

    public static equalsTo(value1: string, value2: string): boolean | string {
        let ok = false;
        ok = value1 === value2;

        return ok ? true : 'Los valores informados no son iguales!';
    }

    public static emailValid(value): boolean | string {
        return !value || /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(value) || 'Por favor insertar un e-mail válido';
    }

    public static cpfValid(value): boolean | string {
        return !value || /^\d{3}\.\d{3}\.\d{3}\-\d{2}$/.test(value) || "Insira um CPF válido";
    }

    public static dateValid(value): boolean | string {
        const pattern = /^(?:(?:31(\/|-|\.)(?:0?[13578]|1[02]))\1|(?:(?:29|30)(\/|-|\.)(?:0?[13-9]|1[0-2])\2))(?:(?:1[6-9]|[2-9]\d)?\d{2})$|^(?:29(\/|-|\.)0?2\3(?:(?:(?:1[6-9]|[2-9]\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:0?[1-9]|1\d|2[0-8])(\/|-|\.)(?:(?:0?[1-9])|(?:1[0-2]))\4(?:(?:1[6-9]|[2-9]\d)?\d{2})$/;
        if (!value) return true;
        return pattern.test(value) || value.length === 0 || "Fecha no válida.";
    }

    public static celularValid(value): boolean | string {
        const pattern = /(\(\d{2}\)\s)(\d{4,5}\-\d{4})/g;
        return !value || pattern.test(value) || "Insira um número de celular válido";
    }

    public static celularOnlyNineDigitValid(value): boolean | string {
        const pattern = /(\(\d{2}\)\s)(\d{4,5}\-\d{4})/g
        return !value || pattern.test(value) || "Insira um número de celular válido";
    }

    public static nomeSobrenome(value: string): boolean | string {
        const patterNumeric = /\d/;
        const pattern = /^([ \u00c0-\u01ffa-zA-Z'\-])+ ([ \u00c0-\u01ffa-zA-Z'\-])+$/;

        if (!value)
            return true;
        else if (patterNumeric.test(value))
            return "Insira um nome válido"
        return pattern.test(value) || value.length === 0 || "Insira o nome completo";
    }
    public static validarRg(val) {
        const pattern = /^[0-9]{2,3}\.?[0-9]{2,3}\.?[0-9]{3}-?[Xx0-9]{1}$/g;
        return !val || pattern.test(val) || "Insira um RG válido";
    }

    public static tamano_min(value: string, qtdCaracteres: number): boolean | string {
        var result = value?.length < qtdCaracteres
        let erro = "Cantidad Mínima: " + qtdCaracteres + " caracter(es)";

        if (result)
            return erro;
        else return true;
    }

    public static tamano_max(value: string, qtdCaracteres: number): boolean | string {
        var result = value?.length > qtdCaracteres
        let erro = "Cantidad Máxima: " + qtdCaracteres + " caracter(es)";

        if (result) {
            return erro;
        } else {
            return true;
        }
    }

    public static valor_minimo(value: number, min: number): boolean | string {

        if (Utilidades.isNullOrUndefinedOrZero(value)) return true;

        let erro = "Mínimo: " + min + ".";
        if (value >= min)
            return !!value || erro; //!! eso es para converter el valor en boolean
        else return erro;
    }

    public static valor_maximo(value: number, max: number): boolean | string {

        if (Utilidades.isNullOrUndefinedOrZero(value)) return true;

        let erro = "Máximo: " + max + ".";
        if (value <= max)
            return !!value || erro; //!! eso es para converter el valor en boolean
        else return erro;
    }

    public static fichero(file: File): boolean | string {
        var result = (file ? true : false);
        let erro = "No se ha informado el fichero";
        if (result)
            erro = '';
        return result || erro;
    }


}

export class HeaderTemplate {
    public text: string = "";
    public value: string = "";
    public sortable: boolean = true;
    public filterable: boolean = true;
    public width: string;
    public filter: any;
    public sort: any;
    public class: string;
    public cellClass: string;
    public align: string;
    public tag_texto: string;
    public fecha: boolean = false;
    public fecha_hora: boolean = false;
    public moneda: boolean = false;
    public decimal: boolean = false;
    public porcentaje: boolean = false;

    constructor(text: string, value: string, width: string = "", sortable: boolean = false, filter: any = null,
        align: string = "", tag_texto: string = "", clase_td: string = "",
        fecha: boolean = false, fecha_hora: boolean = false, moneda: boolean = false,
        decimal: boolean = false, porcentaje: boolean = false) {
        this.text = text;
        this.value = value;
        this.width = width;
        this.sortable = sortable;
        this.filter = filter;
        this.align = align;
        this.tag_texto = tag_texto;
        this.cellClass = clase_td;
        this.fecha = fecha;
        this.fecha_hora = fecha_hora;
        this.moneda = moneda;
        this.decimal = decimal;
        this.porcentaje = porcentaje;
    }
}

export class AutoCompleteTemplate {
    public text: string | number | object;
    public value: string | number | object;
    public disabled: boolean;
    public divider: boolean;
    public header: string;
    public css: string;
    public defecto: string;

    constructor(text: string | number | object, value: string | number | object, disabled?: boolean, divider?: boolean, header?: string, css?: string, defecto?: string) {
        this.text = text;
        this.value = value;
        this.disabled = disabled;
        this.divider = divider;
        this.header = header;
        this.css = css;
        this.defecto = defecto;
    }

    public static add({ text, value, disabled, divider, header, css, defecto }: { text: string | number | object, value: string | number | object, disabled?: boolean, divider?: boolean, header?: string, css?: string, defecto?: string }) {
        return new AutoCompleteTemplate(text, value, disabled, divider, header, css, defecto);
    }
}

export class ChartData {
    public labels: Array<Array<string> | string>;
    public datasets: Array<datasets>;

    constructor() {
        this.datasets = new Array<datasets>();
    }
}

export class datasets {
    public backgroundColor: Array<string | number> | string;
    public label: Array<Array<string> | string> | string;
    public borderColor: string;
    public data: Array<string | number>;
}

export class Combo {
    public id: string | null;
    public texto: string | null;
    public css_texto: string | null;
    public header: string | null;
}

export enum TipoFicheroCuentaUpload {
    N43 = "UABUAF8ARgBBAFIATwBfADAAMAAyADAA",
    EXCEL = "UABUAF8ARgBBAFIATwBfADAAMAAyADEA",
}
export enum ComboEnum {
    TM_PORCENTAJE_IMPUESTO = "UABUAF8ARgBBAFIATwBfADAAMAAyADEA",
    TM_TIPO_DOCUMENTO = "UABUAF8ARgBBAFIATwBfADAAMAAyADIA",
    TM_SI_NO = "UABUAF8ARgBBAFIATwBfADAAMAAyADMA",
    TIPO_EMPRESA = "UABUAF8ARgBBAFIATwBfADAAMAAyADQA",
    TP_EMPRESA_FACTURACION = "UABUAF8ARgBBAFIATwBfADAAMAAyADUA",
    TP_SERIE = "UABUAF8ARgBBAFIATwBfADAAMAAyADYA",
    TP_TIPO_USUARIO = "UABUAF8ARgBBAFIATwBfADAAMAAyADcA",
    TP_PERFIL = "UABUAF8ARgBBAFIATwBfADAAMAAyADgA",
    TM_PAIS = "UABUAF8ARgBBAFIATwBfADAAMAAyADkA",
    TP_RESPONSABLE_IDIOMA = "UABUAF8ARgBBAFIATwBfADAAMAAyADEAMAA=",
    TM_TIPO_RETENCION = "UABUAF8ARgBBAFIATwBfADAAMAAyADEAMQA=",
    TP_SERIE_NUMEROS = "UABUAF8ARgBBAFIATwBfADAAMAAyADEAMgA=",
    TP_CLIENTE = "UABUAF8ARgBBAFIATwBfADAAMAAyADEAMwA=",
    TM_IDIOMA = "UABUAF8ARgBBAFIATwBfADAAMAAyADEANAA=",
    TM_BANCO_ENTIDAD = "UABUAF8ARgBBAFIATwBfADAAMAAyADEANQA=",
    EMPRESAS_DEL_USUARIO = "UABUAF8ARgBBAFIATwBfADAAMAAyADEANgA=",
    TP_BANCO_CUENTA = "UABUAF8ARgBBAFIATwBfADAAMAAyADEANwA=",
    TM_CUENTA_CONTABLE = "UABUAF8ARgBBAFIATwBfADAAMAAyADEAOAA=",
    TP_CLIENTE_CONTRAPARTIDA = "UABUAF8ARgBBAFIATwBfADAAMAAyADEAOQA=",
    TM_TIPO_FACTURA = "UABUAF8ARgBBAFIATwBfADAAMAAyADIAMAA=",
    SQL_TRAZA = "UABUAF8ARgBBAFIATwBfADAAMAAyADIAMQA=",
    TM_ESTADO_FACTURA = "UABUAF8ARgBBAFIATwBfADAAMAAyADIAMgA=",
    TM_ORIGEN_PRESTAMO = "UABUAF8ARgBBAFIATwBfADAAMAAyADIAMwA=",
    TP_EMPRESA_EJERCICIO = "UABUAF8ARgBBAFIATwBfADAAMAAyADIANAA=",
    TM_TIPO_FACTURA_RECTIFICATIVA = "UABUAF8ARgBBAFIATwBfADAAMAAyADIANQA=",
    TP_FACTURA = "UABUAF8ARgBBAFIATwBfADAAMAAyADIANgA=",
    TP_VERIFACTU_EMPRESA = "UABUAF8ARgBBAFIATwBfADAAMAAyADIANwA=",
    TP_EMPRESA = "UABUAF8ARgBBAFIATwBfADAAMAAyADMAMQA=",
    TP_RESPONSABLE_PERFIL = "UABUAF8ARgBBAFIATwBfADAAMAAyADMAMgA=",
    TM_TIPO_PRODUCTO = "UABUAF8ARgBBAFIATwBfADAAMAAyADMAMwA=",
    TM_UNIDAD = "UABUAF8ARgBBAFIATwBfADAAMAAyADMANAA=",
    TP_PLAN_CONTRATADO = "UABUAF8ARgBBAFIATwBfADAAMAAyADMANQA=",
    TM_PERIODO_PLAN = "UABUAF8ARgBBAFIATwBfADAAMAAyADMANgA=",
    TM_MONEDA = "UABUAF8ARgBBAFIATwBfADAAMAAyADMANwA=",
    TM_APLICACION_CONTABILIDAD = "UABUAF8ARgBBAFIATwBfADAAMAAyADMAOAA=",
    TM_TIPO_PERFIL = "UABUAF8ARgBBAFIATwBfADAAMAAyADMAOQA=",
    TP_DELEGACION = "UABUAF8ARgBBAFIATwBfADAAMAAyADQAMAA=",
    TM_PERIODO = "UABUAF8ARgBBAFIATwBfADAAMAAyADQAMQA=",
    TM_TIPO_AMORTIZACION = "UABUAF8ARgBBAFIATwBfADAAMAAyADQAMwA=",
    TM_MOTIVO_BAJA = "UABUAF8ARgBBAFIATwBfADAAMAAyADQANAA=",
    TM_PROVINCIA = "UABUAF8ARgBBAFIATwBfADAAMAAyADQANQA=",
    TP_TIPO_DE_OPERACION = "UABUAF8ARgBBAFIATwBfADAAMAAyADQANwA=",
    TM_PERIODO_MODELO = "UABUAF8ARgBBAFIATwBfADAAMAAyADQAOAA=",
    TM_TIPO_DE_OPERACION = "UABUAF8ARgBBAFIATwBfADAAMAAyADQANwA=",
    TM_TIPO_PERIODO_MODELO = "UABUAF8ARgBBAFIATwBfADAAMAAyADQAOAA=",
    TP_PRODUCTO = "UABUAF8ARgBBAFIATwBfADAAMAAyADQAOQA=",
    TM_MODELO_HACIENDA = "UABUAF8ARgBBAFIATwBfADAAMAAyADUAMAA=",
    TM_CUENTA_CONTABLE_BUSQUEDA = "UABUAF8ARgBBAFIATwBfADAAMAAyADUAMQA=",
    TM_HACIENDA = "UABUAF8ARgBBAFIATwBfADAAMAAyADUAMgA=",
    TM_TIPO_ACTO = "UABUAF8ARgBBAFIATwBfADAAMAAyADUAMwA=",
    TM_TIPO_APORTACION = "UABUAF8ARgBBAFIATwBfADAAMAAyADUANAA=",
    TP_CONSTITUCION_EMPRESA_SOCIO = "UABUAF8ARgBBAFIATwBfADAAMAAyADUANQA="
}

export enum GRAFICA_ENUM {
    TP_CUENTA_RESULTADOS = "UABUAF8ARgBBAFIATwBfADAAMAAyADIA",
}

export enum CARGA_FICHEROS_CONFIGURACION {
    TP_FACTURA_FICHERO = "UABUAF8ARgBBAFIATwBfADAAMAAyADMAMQA=",
    TP_EMPRESA_FACTURA_REPOSITORIO = "UABUAF8ARgBBAFIATwBfADAAMAAyADMAMgA=",
    TP_BANCO_CUENTA_MOVIMIENTO_FICHERO = "UABUAF8ARgBBAFIATwBfADAAMAAyADMAMwA=",
    TP_BANCO_CUENTA_PRESTAMO_FICHERO = "UABUAF8ARgBBAFIATwBfADAAMAAyADMANAA=",
    TP_BANCO_CUENTA_MOVIMIENTO_DOCUMENTACION = "UABUAF8ARgBBAFIATwBfADAAMAAyADMANQA=",
    TP_NOMINA_FICHERO = "UABUAF8ARgBBAFIATwBfADAAMAAyADMANgA=",
    TP_AMORTIZACION_FICHERO = "UABUAF8ARgBBAFIATwBfADAAMAAyADMANwA="
}

export enum ESTADO_FACTURA {
    TODAS = "UABUAF8ARgBBAFIATwBfADAAMAAyAC0AMQA=",
    PRESUPUESTO = "UABUAF8ARgBBAFIATwBfADAAMAAyADEAMAA=",
    ALBARAN = "UABUAF8ARgBBAFIATwBfADAAMAAyADIAMAA=",
    PREFACTURA = "UABUAF8ARgBBAFIATwBfADAAMAAyADMAMAA=",
    CREADA = "UABUAF8ARgBBAFIATwBfADAAMAAyADQAMAA=",
    ENVIADA = "UABUAF8ARgBBAFIATwBfADAAMAAyADUAMAA=",
    HACIENDA = "UABUAF8ARgBBAFIATwBfADAAMAAyADYAMAA=",
    CREADA_RECIBIDA = "UABUAF8ARgBBAFIATwBfADAAMAAyADEANQAwAA==",
    RECIBIDA = "UABUAF8ARgBBAFIATwBfADAAMAAyADEANgAwAA==",
}

export enum TIPO_FACTURA {
    RECIBO_EMITIDO = "UABUAF8ARgBBAFIATwBfADAAMAAyADEA",
    PRESUPUESTO = "UABUAF8ARgBBAFIATwBfADAAMAAyADIA",
    FACTURA_EMITIDA = "UABUAF8ARgBBAFIATwBfADAAMAAyADMA",
    FACTURA_RECIBIDA = "UABUAF8ARgBBAFIATwBfADAAMAAyADQA",
    RECIBO_RECIBIDO = "UABUAF8ARgBBAFIATwBfADAAMAAyADUA",
    TRANSFERENCIA_ENTRE_CUENTAS = "UABUAF8ARgBBAFIATwBfADAAMAAyADYA",
    TIPO_R = "UABUAF8ARgBBAFIATwBfADAAMAAyAFIA",
    TIPO_E = "UABUAF8ARgBBAFIATwBfADAAMAAyAEUA"
}
function useMath() {
    throw new Error("Function not implemented.");
}

export enum COLORES {
    blue = "#3688fc",
    red = "#fa6767",
    yellow = "#f9bc0d",
    green = "#42d29d",
    primary = "#3688fc",
    secondary = "#919ca7",
    success = "#42d29d",
    info = "#44badc",
    warning = "#f9bc0d",
    danger = "#fa6767",
    light = "#eef2f7",
    dark = "#313a46",
    indigo = "#727cf5",
    purple = "#6b5eae",
    pink = "#ff679b",
    orange = "#ff9041",
    teal = "#02a8b5",
    cyan = "#44badc",
    violet = "#c417db",
    wheat = "#f5deb3"
}

